export default __webpack_public_path__ + "static/media/Arabica-Coffee-Beans-1.8f0bdfb7.jpg";